class StayAISubscriptions extends HTMLElement {
  constructor() {
    super();
    this.productJSON = this.getAttribute("productData");
    this.product = JSON.parse(this.productJSON);
    this.initialVariant = this.getAttribute("currentVariantId");
    this.sellingPlanGroups = JSON.parse(this.getAttribute("sellingPlanGroups"));
    this.frequencyVisible = this.getAttribute("frequencyVisible");
  }
  connectedCallback() {
    this.initWidget();
    this.setupEventListeners();
  }
  initWidget() {
    this.purchaseTypeSubscription = this.querySelector("[for='purchaseTypeSubscription']");
    this.purchaseTypeOneTime = this.querySelector("[for='purchaseTypeOneTime']");
    this.sellingPlanSelector = this.querySelector(".rtx-subscription-dropdown");
    this.subscriptionBox = this.querySelector("[data-retextion-subscription-box]");
    this.subscriptionBoxContainer = this.querySelector(".rtx-subscription-frequency-container");
    this.radioOneTime = this.querySelector('input[value="purchaseTypeOneTime"]');
    this.radioSubscription = this.querySelector('input[value="purchaseTypeSubscription"]');
    this.subscriptionList = this.querySelector('.osr-stay-tab-inner-content')
    const selectedInitialVariant = this.product.variants.find((variant) => variant.id === Number(this.initialVariant));
    this.currentVariant = selectedInitialVariant || this.product.variants[0];
    this.updateSellingPlans();
  }
  // Set up event listeners for the purchase type, frequency and variant selectors
  setupEventListeners() {
    const purchaseTypeRadioButtons = this.querySelectorAll('input[name="purchaseType"]');
    // Handle purchase type change
    purchaseTypeRadioButtons.forEach((radio) =>
      radio.addEventListener("change", () => {
        this[radio.value === "purchaseTypeSubscription" ? "showSubscriptionBox" : "hideSubscriptionBox"]();
        this.updateProductPrice(this.sellingPlanSelector.value);
      }),
    );
    // Handle frequency selector change
    this.sellingPlanSelector.addEventListener("change", (e) => {
      this.updateSellingPlanInput(e.target.value);
      this.updateProductPrice(e.target.value);
    });
    // Handle variant change from URL
    window.addEventListener("popstate", this.updateVariantID());
    this.observeUrlChanges();
    // Handle browser back/forward navigation
    window.addEventListener("pageshow", (event) => {
      if (event.persisted || performance.getEntriesByType("navigation")[0]?.type === "back_forward") {
        this.isSubscriptionOptionSelected()
          ? this.querySelector("label[for='purchaseTypeSubscription']").click()
          : this.querySelector("label[for='purchaseTypeOneTime']").click();
        this.updateSellingPlans();
      }
    });
  }
  // Get variant ID from the URL and update the variant
  updateVariantID = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("variant")) return;
    const variantId = Number(urlParams.get("variant"));
    if (variantId && variantId !== this.currentVariant.id) {
      this.currentVariant = this.product.variants.find((v) => v.id === variantId);
      this.updateSellingPlans();
    }
  };
  // Monitor URL changes without overriding history methods
  observeUrlChanges = () => {
    let lastUrl = window.location.href;
    new MutationObserver(() => {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        this.updateVariantID();
      }
    }).observe(document, { subtree: true, childList: true });
  };


// 
  updateVariantFromInputs = () => {
    const inputs = document.querySelectorAll('input[type="radio"]:checked');
    if (!inputs.length) return;

    const selectedOptions = [];
    inputs.forEach((el) => {
      const pos = Number(el.dataset.optionPosition);
      const val = el.dataset.optionValue;
      selectedOptions[pos - 1] = val;
    });

    const matchedVariant = this.product.variants.find(
      v =>
        v.option1 === selectedOptions[0] &&
        (v.option2 === undefined || v.option2 === selectedOptions[1]) &&
        (v.option3 === undefined || v.option3 === selectedOptions[2])
    );

    if (matchedVariant && matchedVariant.id !== this.currentVariant?.id) {
      this.currentVariant = matchedVariant;
      this.updateSellingPlans();
      this.updateProductPrice(
      this.isSubscriptionOptionSelected() ? this.sellingPlanSelector.value : sellingPlans[0]?.id || "",
    );
    }
  };

  // Populate the subscription frequency selector with selling plans for the current variant
  updateSellingPlans() {
    // Get the selling plans for the current variant
    const stayWidget = this.querySelector(`.stay-ai-subscriptions`);
    if (!stayWidget) return;
    const sellingPlans = this.currentVariant.selling_plan_allocations
      .map((spa) =>
        this.sellingPlanGroups
          .find((g) => g.id === spa.selling_plan_group_id && !g.options[0].name.toLowerCase().includes("bundle"))
          ?.selling_plans.find((sp) => sp.id === spa.selling_plan_id),
      )
      .filter(Boolean);
    if (sellingPlans.length == 0) {
      this.updateSellingPlanInput("");
      stayWidget.classList.toggle("is-visible", false);
      console.log("No SPs, hiding widget");
      return;
    } else stayWidget.classList.toggle("is-visible", true);
    // Clear existing options and populate dropdown
    this.sellingPlanSelector.innerHTML = sellingPlans
      .map((plan) => `<option value="${plan.id}">${plan.options[0].value}</option>`)
      .join("");
    if (!this.isSubscriptionOptionSelected()) {
      this.addSelectFrequencyOption();
      this.updateSellingPlanInput("");
    } else {
      this.updateSellingPlanInput(sellingPlans[0]?.id || "");
    }

    // Show or hide the subscription frequency selector
    this.subscriptionBox.classList.toggle("is-visible", this.isSubscriptionOptionSelected());
    this.subscriptionList.classList.toggle("is-striked", !this.isSubscriptionOptionSelected())
    if (this.subscriptionBoxContainer)
      this.subscriptionBoxContainer.classList.toggle("subscriptionBoxContainer", this.isSubscriptionOptionSelected());
    // Update prices
    this.updateProductPrice(
      this.isSubscriptionOptionSelected() ? this.sellingPlanSelector.value : sellingPlans[0]?.id || "",
    );
  }
  // Add "Select frequency" option to the frequency selector
  addSelectFrequencyOption() {
    if (!this.sellingPlanSelector.querySelector('option[value=""]')) {
      this.sellingPlanSelector.insertAdjacentHTML("afterbegin", '<option value="" selected>Select frequency</option>');
    }
  }
  // Show the subscription frequency selector
  showSubscriptionBox() {
    this.subscriptionBox.classList.toggle("disable", false);
    this.subscriptionBox.classList.toggle("is-visible", true);
    this.subscriptionList.classList.toggle("is-striked", false)
    if (this.subscriptionBoxContainer) this.subscriptionBoxContainer.classList.toggle("subscriptionBoxContainer", true);
    this.purchaseTypeSubscription.classList.toggle("is-selected", true);
    this.purchaseTypeOneTime.classList.toggle("is-selected", false);
    this.sellingPlanSelector.querySelector('option[value=""]')?.remove();
    this.updateSellingPlanInput(this.sellingPlanSelector.value);
  }
  // Hide the subscription frequency selector
  hideSubscriptionBox() {
    this.addSelectFrequencyOption();
    if (this.subscriptionBoxContainer) this.subscriptionBoxContainer.classList.toggle("is-visible", false);
    this.subscriptionBox.classList.toggle("is-visible", false);
    this.subscriptionList.classList.toggle("is-striked", true)
    this.subscriptionBox.classList.toggle("disable", true);
    this.purchaseTypeSubscription.classList.toggle("is-selected", false);
    this.purchaseTypeOneTime.classList.toggle("is-selected", true);
    this.updateSellingPlanInput("");
  }
  // Check if the subscription option is selected
  isSubscriptionOptionSelected() {
    return this.purchaseTypeSubscription.classList.contains("is-selected");
  }
  //Add selling plan input to form with specified selling plan ID
  updateSellingPlanInput(sellingPlanId) {
    const productForm = document.querySelector(
      'form[action="/cart/add"][data-type="add-to-cart-form"]:not(.installment), ' +
        'form[action="/cart/add"][id*="product-form"]:not(.installment), ' +
        'form[action="/cart/add"][class*="shopify-product-form"]:not(.installment), ' +
        'form[action="/cart/add"][class*="product-form"]:not(.installment), ' +
        'form[action="/cart/add"]:not(.installment)',
    );

    if (!productForm) return;
    // Find or create the hidden input for selling plan
    let sellingPlanInput = productForm.querySelector("input[name='selling_plan']");
    if (!sellingPlanInput) {
      sellingPlanInput = document.createElement("input");
      sellingPlanInput.type = "hidden";
      sellingPlanInput.name = "selling_plan";
      sellingPlanInput.value = sellingPlanId;
      productForm.appendChild(sellingPlanInput);
    } else {
      sellingPlanInput.value = sellingPlanId;
    }
  }
  updateProductPrice(sellingPlanId) {
    const selectedSellingPlanAllocation = this.currentVariant.selling_plan_allocations.find(
      (spa) => spa.selling_plan_id == sellingPlanId,
    );
    const sellingPlan = this.sellingPlanGroups
      .find((group) => group.selling_plans.some((sp) => sp.id == sellingPlanId))
      ?.selling_plans.find((sp) => sp.id == sellingPlanId);
    const oneTimeLblPrice = this.querySelector("[data-rtx-onetime-price]");
    const subscriptionLblPrice = this.querySelector("[data-rtx-subscription-price]");
    const savingLbl = this.querySelector(".subscription-savings");
    const onetimePrice = this.formatMoney(this.currentVariant.price);
    let subscriptionPrice = onetimePrice;
    // Update one-time price if necessary
    if (oneTimeLblPrice && oneTimeLblPrice.textContent !== onetimePrice) {
      oneTimeLblPrice.textContent = onetimePrice;
    }
    // Update subscription price
    if (selectedSellingPlanAllocation) {
      subscriptionPrice = this.formatMoney(selectedSellingPlanAllocation.price);
      if (subscriptionLblPrice && subscriptionPrice !== subscriptionLblPrice.textContent) {
        subscriptionLblPrice.innerHTML =
          subscriptionPrice !== onetimePrice
            ? `<s class="fullPrice">${onetimePrice}</s>${subscriptionPrice}`
            : subscriptionPrice;
      }
      // Calculate and update savings label
      let discount = this.currentVariant.price - selectedSellingPlanAllocation.price;
      if (discount > 0) {
        if (sellingPlan?.price_adjustments[0].value_type === "percentage") {
          discount = `${sellingPlan.price_adjustments[0].value}%`;
        } else {
          discount = this.formatMoney(discount);
        }
        if (savingLbl.textContent !== discount) savingLbl.textContent = discount;
      } else {
        savingLbl.textContent = "";
      }
    }
  }
  // Toggle checked state based on the currently checked radio button
  toggleRadioButtons() {
    this.radioOneTime.checked = !this.radioOneTime.checked;
    this.radioSubscription.checked = !this.radioSubscription.checked;
  }
  // Format money based on Shopify's active currency
  formatMoney(money) {
    const { Shopify, theme } = window;
    const currency = Shopify?.currency?.active || "USD";
    const locale = Shopify?.locale || "en";
    const hasShopifyFormatMoney = Shopify && typeof Shopify?.formatMoney === "function";
    const hasThemeUtilsFormatMoney = theme?.utils && typeof theme?.utils?.formatMoney === "function";
    const formattedMoney = (money / 100).toFixed(2);
    let formatted;
    const currencyFormatter = new Intl.NumberFormat(locale, {
      currency,
      style: "currency",
    });
    if (!hasShopifyFormatMoney && !hasThemeUtilsFormatMoney) {
      return currencyFormatter.format(Number(formattedMoney));
    }
    formatted = hasShopifyFormatMoney ? Shopify.formatMoney(money) : theme.utils.formatMoney(money);
    return formatted || currencyFormatter.format(Number(formattedMoney));
  }
}
// Define the custom element
customElements.define("purchase-options", StayAISubscriptions);
